import URLSearchParams from 'url-search-params'

const baseHeaders = {
  'Accept': 'application/json',
}

function bootstrapCSRFHeader () {
  document.removeEventListener('readystatechange', bootstrapCSRFHeader)

  var csrfToken = null

  if (document.querySelector('[name=csrfmiddlewaretoken]')) {
    baseHeaders['X-CSRFToken'] = document.querySelector('[name=csrfmiddlewaretoken]').value
  }

}

if ((document.readyState === 'interactive' || document.readyState === 'complete')) {
  bootstrapCSRFHeader()
} else {
  document.addEventListener('readystatechange', bootstrapCSRFHeader)
}

async function _fetch (method, url, data = {}, headers = {}) {
  const fetchConfig = {
    credentials: 'include',
    headers: { ...baseHeaders, ...headers },
    method,
  }

  if (data) {
    if (headers['Content-Type'] == 'application/json') {
      fetchConfig.body = JSON.stringify(data)
    } else {
      const formData = new FormData()
      let hasData = false

      for (const [key, value] of Object.entries(data)) {
        // Non-strict equality on purpose for weeding out null or undefined but keeping everything else.
        if (value != null) {
          if (Array.isArray(value)) {
            value.forEach((value) => formData.append(key, value))
          } else {
            formData.set(key, value)
          }

          hasData = true
        }
      }

      if (hasData) {
        fetchConfig.body = formData
      }
    }
  }

  const response = await fetch(url, fetchConfig)

  let responseData

  try {
    responseData = await response.json()
  } catch {
    // pass
  }

  return {
    ok: response.ok,
    status: response.status,
    statusText: response.statusText,
    data: responseData,
  }
}

export { _fetch as fetch }

export function generateURL (url, data) {
  if (data) {
    for (const key of Object.keys(data)) {
      if (key === '?') {
        const search = new URLSearchParams()

        for (const [queryKey, queryValue] of Object.entries(data[key])) {
          if (queryValue != null) {
            if (Array.isArray(queryValue)) {
              queryValue.forEach((value) => search.append(queryKey, value))
            } else {
              search.set(queryKey, queryValue)
            }
          }
        }

        const searchString = search.toString()

        if (searchString.length) {
          if (url.includes('?')) {
            url += `&${searchString}`
          } else {
            url += `?${searchString}`
          }
        }
      } else {
        url = url.replace(new RegExp(`:${key}`, 'g'), data[key])
      }
    }
  }

  return url
}



// WEBPACK FOOTER //
// ./src/utils/api.js